import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import { Link } from "react-router-dom";
import moment from "moment";

import _, { toNumber } from "lodash";
import "react-overlay-loader/styles.css";
import axios from "axios";

class BudgetDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgId: "",
      startDate: new Date(),
      endDate: new Date(),
      expDate: new Date(),
      prevexpDate: new Date(),
      principalName: "",
      programNumber: "",
      description: "",
      programType: "",
      budgetType: "",
      budget: 0,
      salesTarget: 0,
      programMember: "",
      totalParticipant: "",
      ref_number: "",
      participant: [],
      productList: [],
      documentList: [],
      notes: "",
      attachment: [],
      lovBudget: [],
      lovProgramType: [],
      lovDocument: [],
      lovProgramMember: [],
      error: [],
      docContainer: [],
      success: "",
      is_update: false,
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fileContainer: {},
      pphType: "",
      pphRate: "",
      lovPPH: [],
      submitteddate: "",
      programID: 0,
      prevbudget: 0,
    };
  }

  componentDidMount = () => {
    let user = JSON.parse(window.localStorage.getItem("is_user"));
    let principalName = user.org_name;
    this.setState({ principalName: principalName });
    this.getBudgetType();
    this.getProgramType();
    this.getDetailProgram();
    this.getPPHType();
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/program/detail";
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { header, docs, attachment, product } = response.data.data;
        this.setState({
          loading: false,
          description: header.description,
          startDate: new Date(header.start_date),
          endDate: new Date(header.end_date),
          expDate: new Date(header.claim_exp_date),
          prevexpDate: new Date(header.claim_exp_date),
          programType: header.program_type_id,
          budgetType: header.budget_type_id,
          programMember: header.program_member_id,
          budget: header.budget.toLocaleString("en"),
          prevbudget: header.budget.toLocaleString("en"),
          salesTarget: header.sales_target.toLocaleString("en"),
          totalParticipant: header.total_participant,
          notes: header.notes,
          docContainer: docs,
          is_update: header.status === "P" ? true : false,
          fileContainer: attachment,
          productList: product,
          ref_number: header.ref_number,
          programNumber: header.program_number,
          pphType: header.pph_type,
          pphRate: header.pph_rate,
          programID: header.program_id,
          orgId: header.org_id,
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
        });
        this.getProgramMember();
        this.getDocumentList();
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getProgramMember = () => {
    let url = "/api/traces/v1/general/program-type?orgId=" + this.state.orgId;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramType: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getProgramType = () => {
    let url = "/api/traces/v1/general/member-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramMember: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getPPHType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getBudgetType = () => {
    let url = "/api/traces/v1/general/budget-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovBudget: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getDocumentList = () => {
    let url = "/api/traces/v1/general/document-list?orgId=" + this.state.orgId;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovDocument: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  handleInputProduct = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { productList } = this.state;
    productList[index].productName = e.target.value;
    this.setState(productList);
  };

  renderLovPPh = () => {
    return (
      <select
        className="form-control"
        name="pphType"
        disabled
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  renderProduct = () => {
    return this.state.productList.map((item, index) => (
      <div className="form-group row" key={index}>
        <div className="col-sm-4">
          <input
            type="text"
            disabled
            autoComplete="off"
            className="form-control"
            data-index={index}
            // placeholder="Search Product..."
            onChange={this.handleInputProduct.bind(this)}
            value={item.item_description}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            // disabled
            // autoComplete="off"
            className="form-control"
            data-index={index}
            currentindex={index}
            placeholder="Product reff..."
            onChange={this.onChangeProductReff.bind(this)}
            value={item.item_reff == null ? "" : item.item_reff}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            // disabled
            // autoComplete="off"
            currentindex={index}
            className="form-control"
            data-index={index}
            placeholder="Product budget..."
            onChange={this.onChangeProductBudget.bind(this)}
            value={item.item_budget == null ? "" : item.item_budget}
          />
        </div>
      </div>
    ));
  };

  onChangeProductReff = (event) => {
    let value = event.target.value.length > 0 ? event.target.value : "";
    let currentindex = event.target.attributes.getNamedItem("currentindex")
      .value;
    let { productList } = this.state;

    productList[currentindex].item_reff = value;
    this.setState(productList);
    console.log(this.state.productList);
  };

  onChangeProductBudget = (event) => {
    let value = event.target.value.length > 0 ? event.target.value : "";
    let currentindex = event.target.attributes.getNamedItem("currentindex")
      .value;
    let { productList } = this.state;

    productList[currentindex].item_budget = this.thousandSeparator(value);
    this.setState(productList);
    console.log(this.state.productList);
  };

  replicateProduct = () => {
    let { productList } = this.state;
    productList.push({ productName: "", productId: "" });
    this.setState(productList);
  };

  removeProduct = (index) => {
    if (this.state.productList.length === 1) {
      alert("You must have at least 1 product");
      return false;
    }
    let { productList } = this.state;
    productList.splice(index, 1);
    this.setState(productList);
  };

  setChecked = (item) => {
    let find = _.find(this.state.docContainer, function (o) {
      return o.document_id === item.document_id;
    });
    return find ? true : false;
  };

  renderDocument = () => {
    return this.state.lovDocument.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            disabled
            className="form-check-input"
            defaultChecked={this.setChecked(item)}
            type="checkbox"
            value={item.document_id}
            onClick={this.handleClickDocument.bind(this)}
            id="defaultCheck1"
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {item.document_name}
          </label>
        </div>
      </div>
    ));
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.documentId) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  replicateDocument = () => {
    let { documentList } = this.state;
    documentList.push({ documentName: "", documentId: "" });
    this.setState(documentList);
  };

  removeDocument = (index) => {
    if (this.state.documentList.length === 1) {
      alert("You must have at least 1 document");
      return false;
    }
    let { documentList } = this.state;
    documentList.splice(index, 1);
    this.setState(documentList);
  };

  handleInputDocument = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { documentList } = this.state;
    documentList[index].documentName = e.target.value;
    this.setState(documentList);
  };

  renderLovBudget = () => {
    return (
      <select
        className="form-control"
        disabled
        name="budgetType"
        value={this.state.budgetType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Budget -</option>
        {this.state.lovBudget.map((item, index) => (
          <option value={item.budget_type_id} key={index}>
            {item.budget_type}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgram = () => {
    return (
      <select
        className="form-control"
        disabled
        name="programType"
        value={this.state.programType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Program -</option>
        {this.state.lovProgramType.map((item, index) => (
          <option value={item.prog_type_id} key={index}>
            {item.program_name}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgramMember = () => {
    return (
      <select
        className="form-control"
        disabled
        name="programMember"
        value={this.state.programMember}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Participants - </option>
        {this.state.lovProgramMember.map((item, index) => (
          <option value={item.program_member_id} key={index}>
            {item.description}
          </option>
        ))}
      </select>
    );
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ [name]: value });
    window.setTimeout(() => {
      console.log(this.state);
    }, 100);
  };

  handleChangeBudget = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ [name]: this.thousandSeparator(value) });
    window.setTimeout(() => {
      console.log(this.state);
    }, 100);
  };

  thousandSeparator = (value) => {
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (value.length > 2) {
      value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    }
    return value;
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date });
  };

  handleExpDate = (date) => {
    this.setState({ expDate: date });
  };

  resetForm = () => {
    this.setState({
      description: "",
      start_date: new Date(),
      end_date: new Date(),
      claim_exp_date: new Date(),
      program_type_id: "",
      budget_type_id: "",
      budget: 0,
      sales_target: 0,
      program_member_id: "",
      total_participant: "",
      notes: "",
      document_list: [],
    });
  };

  validationForm = () => {
    let count = 0;
    let error = this.state.error;
    this.setState({ error: [], success: "" });

    // let { productList } = this.state;
    let productList = this.state.productList;

    console.log(productList);

    let totalAmountProduct = 0;
    productList.forEach((item, index) => {
      totalAmountProduct += parseInt(
        this.removeSeparator(item.item_budget || 0)
      );
    });

    this.setState({ error: [], success: "" });

    console.log(totalAmountProduct);
    console.log(parseInt(this.removeSeparator(this.state.budget)));

    if (this.state.budget === 0 || this.state.budget === "") {
      error.push("Budget is empty");
      ++count;
    } else if (
      totalAmountProduct > 0 &&
      totalAmountProduct !== parseInt(this.removeSeparator(this.state.budget))
    ) {
      error.push(
        "Total budget of products must be 0 or equal with budget program"
      );
      ++count;
    }

    if (count > 0) {
      this.setState({ error: error });
      window.scrollTo(0, 0);
      return false;
    } else {
      return true;
    }
  };

  handleUpdate = () => {
    if (this.validationForm()) {
      let url = "/api/traces/v1/program/updatebudget";

      let productContainer = this.state.productList.map((item, index) => {
        item.item_budget = this.removeSeparator(item.item_budget);
        item.item_reff = item.item_reff == null ? "" : item.item_reff;
        return item;
      });
      let param = {
        source: "infostep",
        menu: "program",
        function: "update program",
        principal_code: this.state.user.org_initial,
        program_id: this.state.programID,
        org_id: this.state.user.org_id,
        budget: this.removeSeparator(this.state.budget),
        prev_budget: this.removeSeparator(this.state.prevbudget),
        product_list: productContainer,
        user_id: this.state.user.user_id,
        user_name: this.state.user.user_name,
        claim_exp_date: moment(this.state.expDate).format("YYYY-MM-DD"),
        prev_claim_exp_date: moment(this.state.prevexpDate).format(
          "YYYY-MM-DD"
        ),
        user_name: this.state.user.username,
      };
      this.setState({ loading: true });
      request.postTraces(url, param, {
        success: function (response) {
          let { message } = response.data;
          window.scrollTo(0, 0);
          this.setState({ loading: false, success: message });
          window.setTimeout(() => {
            this.props.history.push("/admin/program/updatebudget");
          }, 2000);
        }.bind(this),
        error: function (e) {
          console.log(e);
          this.setState({ loading: false });
        }.bind(this),
      });
    }
  };

  //   handleReject = () => {
  //     this.handleRequestUpdate("R", []);
  //   };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          {this.state.success}
        </div>
      );
    }
  };

  renderButton = () => {
    return (
      <div className="col-sm-8">
        <button
          type="button"
          className="btn btn-success"
          onClick={this.handleUpdate.bind(this)}
        >
          Update
        </button>
        &nbsp;
        {/* <button
            type="button"
            className="btn btn-danger"
            onClick={this.handleReject.bind(this)}
          >
            Reject
          </button> */}
        &nbsp;
        <button
          type="button"
          className="btn btn-warning"
          onClick={this.handleCancel.bind(this)}
        >
          Cancel
        </button>
      </div>
    );
  };

  handleCancel = () => {
    this.props.history.push("/admin/program/updatebudget");
  };

  renderProductList = () => {
    return (
      <table className="table table-striped table-sm table-bordered">
        <tr className="table-primary">
          <th>Product Description</th>
          <th>Product Reff</th>
          <th>Product Budget</th>
        </tr>
        {this.state.productList.map((item, index) => (
          <tr>
            <td>{item.item_description}</td>
            <td>{item.item_reff}</td>
            <td>{item.item_budget}</td>
          </tr>
        ))}
      </table>
    );
  };

  handleRedirect = (e) => {
    e.preventDefault()
    const url = request.getFileS3('principal-doc', this.state.fileContainer.filename);
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  };

  renderAttachment = () => {
    if (this.state.fileContainer && this.state.fileContainer.fullurl) {
      return (
        <div className="col-md-6">
          Files:
          <br />
          <p>
            <a
              href="#"
              onClick={this.handleRedirect.bind(this)}
              target="blank"
              rel="noopener noreferrer"
            >
              {this.state.fileContainer.filename}
            </a>
          </p>
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  {/* <div className="card-header">Form</div> */}
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Number
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programNumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Principal
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.principalName}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Reff Number / SKP
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                placeholder="Reference Number"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ref_number}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovProgram()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Descriptions
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="description"
                                placeholder="Description"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.description}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Budget Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovBudget()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Submitted Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.submitteddate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Start Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.startDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleStartDate}
                                disabled
                              />
                            </div>
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-2 col-form-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.endDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleEndDate}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Claim Exp Date
                            </label>
                            <div className="col-sm-8">
                              <DatePicker
                                selected={this.state.expDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleExpDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeBudget.bind(this)}
                                value={this.state.budget}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Sales Target
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Sales Target"
                                name="salesTarget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.salesTarget}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovPPh()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              PPh Rate (%)
                            </label>
                            <div className="col-sm-4">
                              <input
                                disabled
                                type="number"
                                max="100"
                                min="0"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphRate"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Claim Documents</h5>
                          <div className="row">{this.renderDocument()}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <h5>Participants</h5>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Participants Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovProgramMember()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Total Participant
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="number"
                                disabled
                                className="form-control"
                                name="totalParticipant"
                                value={this.state.totalParticipant}
                                onChange={this.handleChangeInput.bind(this)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-12">
                          <h5>Products</h5>
                          {/* {this.renderProductList()} */}
                          {this.renderProduct()}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Notes Participants
                            </label>
                            <div className="col-sm-8">
                              <textarea
                                disabled
                                cols="10"
                                rows="5"
                                className="form-control"
                                name="notes"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.notes}
                              ></textarea>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            ></label>
                            {this.renderButton()}
                          </div>
                        </div>
                        {this.renderAttachment()}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default BudgetDetail;
